import { ScrollIndicatedDialogContent } from '../components/ScrollIndicatedDialogContent';

export default ScrollIndicatedDialogContent;
